import { Form as FactorialForm } from 'factorial-form'

class AttendancePolicyForm extends FactorialForm {
  constructor(values: {}) {
    super(values, {
      name: 'string',
      description: 'string',
      enabled: 'boolean',
      default: 'boolean',
    })
  }
}

export default AttendancePolicyForm
